import Slider, { type SliderProps } from './slider';

export type { SliderProps };
export default Slider;
